import {
    ThemeProvider,
    ModalProvider,
    getMetaTag,
    PlatformProvider,
    SidePanelProvider,
    GlobalCacheProvider
} from "shared";
import { AuthProvider, PropertiesProvider } from "entities/user";
import { ShareStateProvider } from "features/components";
import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/en";
import emotionCreateCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { RoutesComponent } from "./routes_component";

const utc = require("dayjs/plugin/utc");
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
dayjs.extend(utc);

export const App = () => {
    const nonce = getMetaTag("csp-nonce", "property");
    const emotionCache = emotionCreateCache({
        key: "cdoc-emotion-cache-key",
        nonce: nonce
    });

    return (
        <CacheProvider value={emotionCache}>
            <ThemeProvider>
                <GlobalCacheProvider>
                    <PlatformProvider>
                        <AuthProvider>
                            <PropertiesProvider>
                                <ModalProvider>
                                    <SidePanelProvider>
                                        <ShareStateProvider>
                                            <RoutesComponent/>
                                        </ShareStateProvider>
                                    </SidePanelProvider>
                                </ModalProvider>
                            </PropertiesProvider>
                        </AuthProvider>
                    </PlatformProvider>
                </GlobalCacheProvider>
            </ThemeProvider>
        </CacheProvider>
    );
};
